import _ from 'lodash'
import moment from 'moment'
import React, { useState } from 'react'
import { Bar } from 'react-chartjs-2'
import SqaureLoader from '../../../components/Loader/SqaureLoader'

export default function GraphparFamille({ t, familles, listeFamilles, loading, date1, date2 }) {

    const [title, settitle] = useState("")
    //---------- ITEMS Graphes --------------
    const [labels, setlabels] = useState([])
    const [data, setdata] = useState([])

    const detailsGammes = (g, name) => {
        if (g === "all") {
            // Grouped  by date Exemple ['2022-02-01','2022-01-17']

        } else {
            settitle(name)
            const li = listeFamilles?.filter((el) => el.famille_code === g)
            const gr = _.groupBy(li, "date")
            console.log(listeFamilles)
            const x = []
            for (let value of Object.keys(gr)) {
                x.push(moment(value).format("YYYY-MM-DD"))
            }
            const l = _.uniq(x)
            setlabels(l)
            var y = []
            var arr = []
            for (let value of Object.values(gr)) {
                y.push(value[0].total)
            }
            arr.push({
                label: t('rapportGraph.ruptureparFamille') + " " + name,
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
                data: y
            })
            setdata(arr)
        }

    }

    return (
        <div className="panel-group" id="accordion2" role="tablist" aria-multiselectable="true" style={{ marginBottom: '10px' }}>
            <div className="panel panel-default active">
                <div className="panel-heading " role="tab" id="headingTwo">
                    <h4 className="panel-title">
                        <a role="button" data-toggle="collapse" data-parent="#accordion2" className='fs-12' href="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                            <i className="icon icon-grid text-primary mr-2" /> {t('rapportGraph.ruptureparFamille')}
                            <span className="float-right"> <i className="fe fe-search  text-primary" />  </span>
                        </a>
                    </h4>
                </div>
                <div id="collapseTwo" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                    <div className="panel-body">
                        {loading ? <SqaureLoader /> :
                            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2'>
                                <div className="tags mb-2  text-center" style={{ alignContent: "center" }}>
                                    <label className='mr-3 fs-12'><i className='icon icon-equalizer mr-1' />  {t('rapportGraph.filtreparfamille')} : </label>
                                    <button className="btn tag bg-azure text-white" onClick={() => detailsGammes("all", "all")}> {t('rapports.ALL')} </button>

                                    {familles?.map((items, keys) => (
                                        <button className="btn tag bg-purple" key={keys} onClick={() => detailsGammes(items.famille_code, items.famille)}> {items.famille}</button>
                                    ))}
                                </div>
                                <Bar
                                    data={{
                                        labels: labels,
                                        datasets: data
                                    }}

                                    options={{
                                        plugins: {
                                            legend: {
                                                possition: 'top',
                                            },
                                            title: {
                                                display: true,
                                                text: t('rapportGraph.ruptureparFamille') + " " + title
                                            }
                                        },
                                        scales: {
                                            x: {
                                                display: true,
                                                title: {
                                                    display: true,
                                                    text: t('dashboard.Date'),
                                                    font: {
                                                        family: 'Poppins',
                                                        size: 16,
                                                        style: 'normal',
                                                        lineHeight: 1.2
                                                    },
                                                    padding: { top: 20, left: 0, right: 0, bottom: 0 }
                                                }
                                            },
                                            y: {
                                                display: true,
                                                title: {
                                                    display: true,
                                                    text: t('Produits.Quantite'),
                                                    font: {
                                                        family: 'Poppins',
                                                        size: 16,
                                                        style: 'normal',
                                                        lineHeight: 1.2
                                                    },
                                                    padding: { top: 30, left: 0, right: 0, bottom: 0 }
                                                }
                                            }
                                        }
                                    }}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
